module.exports = __webpack_public_path__ + "img/snabjenie.6e20fe4b.svg";